import HomeContainer from './home_container';

const Home = HomeContainer;
export default Home;
